import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Avatar, Box, Typography } from "@mui/material";
import { useAuthenticationStore } from "../../../stores/auth";
import { FruitifyMetrics } from "../components/FruitifyMetrics";

function SuperuserDashboard() {
  const { user } = useAuthenticationStore();

  return (
    <FruitifyContainer data-testid={"teacher-dashboard"}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        sx={{ mb: 3 }}
      >
        <Avatar />

        <Box>
          <Typography variant="h5">
            Welcome back, {user.info.firstName}!
          </Typography>
        </Box>
      </Box>
      <FruitifyMetrics />
    </FruitifyContainer>
  );
}

export default SuperuserDashboard;
